// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","461":"b637e9a5"}[chunkId] || chunkId) + "-" + {"245":"49222344593d3edd3250","461":"43a769c6b6102a014ca0","577":"4b7dfcfce70d94e003b2"}[chunkId] + ".js";
};